/*
 * @Desc:
 * @Author: zcc
 * @Date: 2022-11-03 17:09:53
 * @LastEditors: zcc
 * @LastEditTime: 2022-11-22 15:58:04
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './permission'
import '@/assets/iconfont/iconfont.css'
import 'element-plus/dist/index.css'
import { globalComponentsName } from '@/utils/index'
import dic from '@/utils/dic'
// elemnt-plus 字体图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

/** 设置element-plus 主题色 -start----------**/
const el = document.documentElement
// 获取 css 变量
getComputedStyle(el).getPropertyValue('--el-color-primary')
// 设置 css 变量
el.style.setProperty('--el-color-primary', '#004BAA')
const app = createApp(App)

/** 设置element-plus 主题色 -end----------**/
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 全局引入components组件
globalComponentsName(require.context('@/components', true, /\.vue$/), app)
app.config.globalProperties.$dic = dic
app.use(store).use(router).mount('#app')
